// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"PaymentsTab_totalRow__2A6y-"};